//Container 디자인 관리

import styled from 'styled-components';

export const Container = styled.div`
  text-align: left;
  width: 360px;
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 9px;
  padding: 20px;
  padding-top: 0px;
`;

export const InputBox = styled.header`
  font-family: 'SuncheonB';
  flex: 0.2;
  text-align: center;
`;
